import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { ToastContainer } from 'react-toastify';
import Header from '../../components/common/Header/Header';
import PasswordSettings from './PasswordSettings';
import OTPSettings from './OTPSettings';
import './SecuritySettings.scss';

const SecuritySettings = () => {
  const { t } = useTranslation();
  return (
    <Container fluid className="pr-0">
      <Header
        linkTo={'/admin/admin-dashboard'}
        header={t('admin.pages.security_settings.module')}
      />
      <Row>
        <Col>
          <Tabs defaultTab="password-setting" vertical>
            <TabList>
              <Tab tabFor="password-setting" role="navigation">
                Password Setting
              </Tab>
              <Tab tabFor="otp-setting" role="navigation">
                One Time Password Setting
              </Tab>
            </TabList>

            <TabPanel tabId="password-setting" className="">
              <PasswordSettings />
            </TabPanel>

            <TabPanel tabId="otp-setting" className="">
              <OTPSettings />
            </TabPanel>
          </Tabs>
        </Col>
      </Row>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Container>
  );
};

export default SecuritySettings;
